'use client';
import Lottie from 'lottie-react';
import { BoxComponent } from '../box/Box';
// const LoaderAnimation = require('./assets/mainLoader.json');
import * as LoaderAnimation from './assets/mainLoader.json';
//TODO: Change this 'require' import to regular import

export function MiniLoader({ ...otherProps }) {
  return (
    <BoxComponent
      sx={{
        height: '100px',
        width: '100px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        ...(otherProps.sx || {}),
      }}
    >
      <Lottie animationData={LoaderAnimation} loop={true} />
    </BoxComponent>
  );
}
